import { css } from 'styled-components';

export const ie11ReadOnlyStyles = css`
  pointer-events: none;
`;
